/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.video.defs'

export { $nsid }

type JobStatus = {
  $type?: 'app.bsky.video.defs#jobStatus'
  jobId: string
  did: l.DidString

  /**
   * The state of the video processing job. All values not listed as a known value indicate that the job is in process.
   */
  state: 'JOB_STATE_COMPLETED' | 'JOB_STATE_FAILED' | l.UnknownString

  /**
   * Progress within the current processing state.
   */
  progress?: number
  blob?: l.BlobRef
  error?: string
  message?: string
}

export type { JobStatus }

const jobStatus = /*#__PURE__*/ l.typedObject<JobStatus>(
  $nsid,
  'jobStatus',
  /*#__PURE__*/ l.object({
    jobId: /*#__PURE__*/ l.string(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    state: /*#__PURE__*/ l.string<{
      knownValues: ['JOB_STATE_COMPLETED', 'JOB_STATE_FAILED']
    }>(),
    progress: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0, maximum: 100 }),
    ),
    blob: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.blob()),
    error: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    message: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { jobStatus }
